namespace RecordShield.Modules.Administration.DeviceLog {
    export enum OpCode {
        LogIn = 1,
        LogOut = 2,
        Unblock = 3,
        Attempt = 4
    }
    Serenity.Decorators.registerEnum(OpCode, 'RecordShield.Modules.Administration.DeviceLog.OpCode');
}
